import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import GenericInsurance from "./GenericInsurance";
import FormWizzard from "./FormWizzard";

export default class PrivateLiability extends GenericInsurance {
  render() {
    return (
      <div className="App" style={{ width: "100%" }}>
        <h2 style={{ textAlign: "left" }}>Private Liability Insurance</h2>

        <p style={{ textAlign: "left" }}>
          In order to provide you the best and fast private liability insurance,
          please provide the data requested bellow.
        </p>
        <Container fluid>
          <Row>
            <Col className="col-12" style={{ textAlign: "left" }}>
              <FormWizzard
                payload={this.getPayload()}
                productName="Private Liability Insurance"
                amountOptions={[
                  "100.000.000 CHF",
                  "200.000.000 CHF",
                  "300.000.000 CHF",
                  "400.000.000 CHF",
                  "500.000.000 CHF",
                ]}
                durationOptions={[
                  "1 year",
                  "2 years",
                  "3 years",
                  "4 years",
                  "5 years",
                  "6 years",
                  "7 years",
                  "8 years",
                  "9 years",
                  "10 years",
                ]}
                onApply={() => this.showLoginDialog()}
                termsAccepted={false}
              ></FormWizzard>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
